export default [
    {
        path: 'relatorio-quantitativo-cid',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-cid' */
            '@/views/ambulatorio/relatorio-quantitativo-cid/Index'
        ),
        redirect: 'relatorio-quantitativo-cid/index',
        children: [
            {
                name: 'ambulatorio-relatorio-quantitativo-cid-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-cid' */
                    '@/views/ambulatorio/relatorio-quantitativo-cid/List.vue'
                ),
            },
        ],
    },
]